<eva-drawer
  [visible]="(helpService.visible$ | async) ?? false"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  width="400px"
  header="Centre d'aide"
  subtitle="Trouvez rapidement l'information dont vous avez besoin"
>
  <div class="eva-help-drawer__items">
    <button type="button" class="eva-help-drawer__item" (click)="openDocumentation()">
      <ng-icon name="heroBookOpen"></ng-icon>
      <div class="eva-help-drawer__item-text">
        <span class="eva-help-drawer__item-label">Documentation</span>
        <span class="eva-help-drawer__item-description">Guides et tutoriels</span>
      </div>
      <ng-icon name="heroChevronRight" class="eva-help-drawer__item-arrow"></ng-icon>
    </button>
    <a
      class="eva-help-drawer__item"
      href="https://www.youtube.com/playlist?list=PLxKD5QhccwsYcWURsN6TqkukCA7e_o_jf"
      target="_blank"
      rel="noopener noreferrer"
      (click)="trackVideosClick()"
    >
      <ng-icon name="heroFilm"></ng-icon>
      <div class="eva-help-drawer__item-text">
        <span class="eva-help-drawer__item-label">Vidéos</span>
        <span class="eva-help-drawer__item-description">Tutoriels vidéo</span>
      </div>
      <ng-icon name="heroChevronRight" class="eva-help-drawer__item-arrow"></ng-icon>
    </a>
    <a
      class="eva-help-drawer__item"
      href="https://aide.eva-it.ch/fr/collections/19745266-nouveautes"
      target="_blank"
      rel="noopener noreferrer"
      (click)="trackNewsClick()"
    >
      <ng-icon name="heroSparkles"></ng-icon>
      <div class="eva-help-drawer__item-text">
        <span class="eva-help-drawer__item-label">Nouveautés</span>
        <span class="eva-help-drawer__item-description">Dernières fonctionnalités</span>
      </div>
      <ng-icon name="heroChevronRight" class="eva-help-drawer__item-arrow"></ng-icon>
    </a>
    <button type="button" class="eva-help-drawer__item" (click)="openSupport()">
      <ng-icon name="heroEnvelope"></ng-icon>
      <div class="eva-help-drawer__item-text">
        <span class="eva-help-drawer__item-label">Contacter le support</span>
        <span class="eva-help-drawer__item-description">Discutez avec notre équipe</span>
      </div>
      <ng-icon name="heroChevronRight" class="eva-help-drawer__item-arrow"></ng-icon>
    </button>
  </div>
</eva-drawer>
